<template>
  <SysMenu
    texto_titulo="Selecione os periodo"
    texto_botao_aceitar="aplicar"
    :max_width="300"
    :min_width="300"
    txt_ativador="Periodo"
    icone_personalizado=""
    @confirmar-menu="aplicarFiltros()"
  >
    <v-radio-group v-model="radio_selecionado" column>
      <v-radio label="Selecionar todos" value="sel" />
      <v-radio label="Desmarcar todos" value="des" />
    </v-radio-group>

    <v-divider class="mb-5" />

    <v-checkbox
      v-for="(m, i) in meses"
      :key="i"
      hide-details
      v-model="selecionados"
      :label="i"
      :value="m"
      @click="radio_selecionado = null"
    ></v-checkbox>
  </SysMenu>
</template>

<script>
import SysMenu from '@/components/utils/SysMenu.vue'
import { mapMutations } from 'vuex';
export default {
  methods: {
    ...mapMutations({
      setFiltrosGraficoTabela: 'EventoSazonalFinal/SET_FILTROS_GRAFICO_TABELA',
    }),
    aplicarFiltros() {
      this.$store.dispatch('EventoSazonalFinal/buscarDadosGrafico');
      this.$store.dispatch('EventoSazonalFinal/buscarDadosTabela');
    },
  },
  mounted() {
    const meses = ['01','02','03','04','05','06','07','08','09','10','11','12'];
    this.selecionados = meses;
  },
  watch: {
    selecionados(valor) {
      this.setFiltrosGraficoTabela({ periodos: valor });
    },
    radio_selecionado(valor) {
      switch (valor) {
        case 'sel':
          this.selecionados = ['01','02','03','04','05','06','07','08','09','10','11','12'];
          break;

        case 'des':
          this.selecionados = [];
          break;
      }
    }
  },
  data: () => ({
    selecionados: null,
    radio_selecionado: null,
    meses: {
      janeiro: '01',
      fevereiro: '02',
      março: '03',
      abril: '04',
      maio: '05',
      junho: '06',
      julho: '07',
      agosto: '08',
      setembro: '09',
      outubro: '10',
      novembro: '11',
      dezembro: '12',
    }
  }),
  components: { SysMenu },
}
</script>

<style>

</style>
